module.exports = __webpack_public_path__ + "img/devbox31.c9bf97ae.png";